export default __webpack_public_path__ + "static/media/landing.51934aba.png";